__turbopack_context__.v({
  "className": "roboto_condensed_4b8dbd98-module__nhE_DG__className",
  "variable": "roboto_condensed_4b8dbd98-module__nhE_DG__variable",
});
